import jwt_decode from 'jwt-decode'

import { Repository } from '../../infrastructure/storage'
import { createSessionClient, RetrieveRequest, SessionConfig } from './session'
import { AnonymousUser } from './user'

export interface AnonymousClient {
  signIn: () => Promise<AnonymousUser>
  refreshToken: () => Promise<AnonymousUser>
  retrieveToken: (request: RetrieveRequest) => Promise<AnonymousUser>
  getToken: () => Promise<string>
}

export const createAnonymousClient = (
  config: SessionConfig,
  repository: Repository<string>,
): AnonymousClient => {
  const client = createSessionClient(config)

  const getToken = async () => {
    let token = repository.get()
    if (!token) {
      token = await client.getToken()
      repository.save(token)
    }
    return token
  }

  return {
    getToken,
    signIn: async () => {
      return toAnonymousUser(await getToken())
    },
    refreshToken: async () => {
      repository.remove()
      return toAnonymousUser(await getToken())
    },
    retrieveToken: async (request: RetrieveRequest) => {
      const token = await client.retrieveToken({ ...request, brand: config.brand })
      repository.save(token)
      return toAnonymousUser(token)
    },
  }
}

const extractSubject = (token: string) => jwt_decode<{ sub: string }>(token).sub
const toAnonymousUser = (accessToken: string) => ({ userId: extractSubject(accessToken) })
